import { Breadcrumbs, Typography } from "@mui/material";

import { ChevronRight } from "lucide-react";

export function ZoneBreadcrumbs({ path }: { path: string[] }) {
  if (!path.length) {
    return null;
  }

  return (
    <Breadcrumbs
      separator={
        <Typography
          color={"neutral.subtle"}
          variant={"bodySmallMedium"}
          sx={{ height: 20 }}
        >
          <ChevronRight size={20} />
        </Typography>
      }
    >
      {path.map((item) => (
        <Typography
          key={item}
          color={"neutral.subtle"}
          variant={"bodySmallMedium"}
        >
          {item}
        </Typography>
      ))}
    </Breadcrumbs>
  );
}
